export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      serviceRssSetting: {
        serviceRssId: 1,
        serviceRssUuid: "servicerss001",
        rssName: "地域の医療情報",
        rssURL: "https://xxxxx.xxxxx.xxx"
      }
    }
  }
}